export const PlannerConstants: Record<string, 'ap3-academic_planner_v3' | 'reg-academic_planner'> = {
  AP3_FT: 'ap3-academic_planner_v3',
  AP1_FT: 'reg-academic_planner'
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/back_to_planner/constants/planner_constants.ts